

export default function MyButton() {
    return (
      <button className="text-base text-center tracking-[0.3em] border bg-transparent border-white shadow-buttonShadow 
      px-6 py-2 uppercase text-white ">
        Enter
      </button>
    );
  }